module.exports = __webpack_public_path__ + "static/media/botSleepZZZ.f4c425cd.svg";